import {Directive, ElementRef, HostBinding, AfterViewInit, ChangeDetectorRef, Renderer2} from '@angular/core';

/*
* Директива для поиска наилучшей позиции на экране для абсолютно позиционированного элемента.
* */

@Directive({
    selector: '[appFindPositionForDatesSelect]'
})
export class FindPositionForDateSelectDirective implements AfterViewInit {
    /**
     * Прозрачность для плавной анимации появления
     * @type {number}
     */
    @HostBinding('style.opacity') private opacity = 0;

    private native: HTMLElement;

    constructor(
        er: ElementRef,
        private renderer: Renderer2,
        private cd: ChangeDetectorRef
    ) {
        this.native = er.nativeElement;
    }

    ngAfterViewInit() {
        /**
         * Если блок уходит выше границы экрана, то сдвигаем его, чтобы поместился на экране
         */
        const {top} = this.native.getBoundingClientRect();

        if (top < 0) {
            this.renderer.setStyle(this.native, 'transform', `translateY(-50px)`);
        }

        this.opacity = 1;
        this.cd.detectChanges();
    }
}
